import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular
import { forwardRef, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgbAccordionModule, NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';

// Pages
import { CoreModule } from '../../core/core.module';
// Partials
import { PartialsModule } from '../partials/partials.module';
import { FaqComponent } from './faq/faq.component';
import { FaqService } from './faq/faq.service';
import { PageViewComponent } from './page-view/page-view.component';
import { PageViewService } from './page-view/page-view.service';
import { ProfileNoticeComponent } from './profile/notice/notice.component';
import { ProfileComponent } from './profile/profile.component';
import { ProfileService } from './profile/profile.service';
import { DynamicPageViewComponent } from './page-view/dynamic-page-view.component';
import { ClicksMonitorComponent } from './monitoring/clicks/clicks-monitor.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ClicksMonitorService } from './monitoring/clicks/clicks-monitor.service';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ExportReportComponent } from './export-report/export-report.component';
import { PowerbiModule } from '../../powerbi/powerbi.module';

@NgModule({
  declarations: [
    PageViewComponent,
    FaqComponent,
    ProfileComponent,
    ProfileNoticeComponent,
    DynamicPageViewComponent,
    DashboardComponent,
    ClicksMonitorComponent,
    ExportReportComponent,
  ],
  exports: [DynamicPageViewComponent],
  entryComponents: [PageViewComponent, ClicksMonitorComponent, ExportReportComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    NgbAccordionModule,
    NgbTabsetModule,
    CoreModule,
    PartialsModule,
    MatCardModule,
    PowerbiModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
  ],
  providers: [FaqService, ProfileService, PageViewService, ClicksMonitorService],
})
export class PagesModule {}
